<template>
  <div class="pt-promo-wrapper" v-if="getLoadead">
    <div
      class="pt-promo-carousel"
      v-if="SCConfig.FieldValues.Parameters.promo_type === 'carousel'"
    >
      <tabs
        v-if="getUserPick === null || getEditState"
        :config="SCConfig"
        :userPick="getUserPick"
      ></tabs>
      <selected-team
        v-else
        :userPick="getUserPick"
        :config="SCConfig"
      ></selected-team>
    </div>
    <selectView v-else :config="SCConfig" :userPick="getUserPick"></selectView>
    <div
      class="pt-logged-out-message"
      v-if="!(getPromoConfig.loggedIn || getPromoConfig.isLoggedIn)"
    >
      {{ SCConfig.FieldValues.Parameters.logged_out_message }}
    </div>
    <div
      v-if="!(getPromoConfig.loggedIn || getPromoConfig.isLoggedIn)"
      class="pt-button__wrapper"
      :class="{
        'pt-button__wrapper--no-sticky':
          SCConfig.FieldValues.Parameters.scticky_login_mobile === 'false'
      }"
    >
      <button
        class="pt-button"
        :aria-label="SCConfig.FieldValues.Parameters.label_login"
        @click="logIn"
        v-html="SCConfig.FieldValues.Parameters.label_login"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex";
import tabs from "@/components/leagues-tabs-component.vue";
import selectedTeam from "@/components/selected-team-component.vue";
import selectView from "@/components/select-view-component.vue";
export default {
  name: "Home",
  components: {
    tabs,
    selectedTeam,
    selectView
  },
  computed: {
    ...mapGetters([
      "getLoadead",
      "getUserPick",
      "getEditState",
      "getPromoConfig",
      "getPromoContent"
    ]),
    SCConfig() {
      return this.getPromoContent.find(item => item.ItemName === "config");
    }
  },
  methods: {
    logIn() {
      if (
        this.getPromoConfig.vanilla6 ||
        this.getPromoConfig.isMobile === "True" ||
        this.getPromoConfig.isNative === "True"
      ) {
        window.location = `/${
          this.getPromoConfig.language
        }/labelhost/login?rurlauth=1&rurl=${encodeURIComponent(
          window.location.href
        )}`;
      } else {
                $.bwin.CenteredLogin.overlay.loadCenteredLogin(window.location.href); // eslint-disable-line
      }
    }
  }
};
</script>
<style scoped>
.pt-promo-wrapper {
  background: var(--pyt-wrapper-bg);
}

.pt-logged-out-message {
  color: var(--pyt-logged-out-color);
  padding: 0 10px 10px;
}
</style>
